// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as Js_dict from "../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Belt_Int from "../../../../node_modules/rescript/lib/es6/belt_Int.js";
import * as GeoRegion from "../../../common/store/GeoRegion.bs.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as UrlUtils$Catalyst from "../../../../node_modules/@porterin/catalyst/src/utils/UrlUtils.bs.js";
import * as Languages$Catalyst from "../../../../node_modules/@porterin/catalyst/src/entities/vernacular/Languages.bs.js";
import * as PartnerScoreErrorConfig from "../domain/store/PartnerScoreErrorConfig.bs.js";
import * as Lib$PorterinFusionkitSentry from "../../../../node_modules/@porterin/fusionkit-sentry/src/Lib.bs.js";
import * as PartnerScoreVernacularConfig from "../domain/store/PartnerScoreVernacularConfig.bs.js";
import * as PartnerScoreVehicleCategoryHelper from "../domain/helper/PartnerScoreVehicleCategoryHelper.bs.js";

function getLanguage(url_params) {
  var lang = Js_dict.get(url_params, "lang");
  if (lang !== undefined) {
    var language;
    try {
      language = Languages$Catalyst.fromCode(lang);
    }
    catch (exn){
      Curry._1(Lib$PorterinFusionkitSentry.React.captureMessage, "Invalid Language");
      language = /* English */0;
    }
    if (List.mem(language, PartnerScoreVernacularConfig.supportedLanguages)) {
      return language;
    } else {
      return /* English */0;
    }
  } else {
    return /* English */0;
  }
}

function getRoute(url) {
  var match = url.path;
  if (!match) {
    return ;
  }
  if (match.hd !== "dashboard") {
    return ;
  }
  var match$1 = match.tl;
  if (!match$1) {
    return ;
  }
  if (match$1.hd !== "score") {
    return ;
  }
  if (match$1.tl) {
    return ;
  }
  var url_params = UrlUtils$Catalyst.getURLParams(url.search);
  var match$2 = Js_dict.get(url_params, "msisdn");
  var match$3 = Js_dict.get(url_params, "auth_token");
  var match$4 = Js_dict.get(url_params, "geo_region_id");
  if (match$2 !== undefined && match$3 !== undefined && match$4 !== undefined) {
    return {
            TAG: /* PartnerScoreDashboard */7,
            _0: match$2,
            _1: match$3,
            _2: getLanguage(url_params),
            _3: PartnerScoreVehicleCategoryHelper.getVehicleCategory(url_params),
            _4: GeoRegion.fromId(Belt_Option.getWithDefault(Belt_Int.fromString(match$4), 1))
          };
  } else {
    return {
            TAG: /* DefaultErrorView */8,
            _0: PartnerScoreErrorConfig.authError
          };
  }
}

export {
  getLanguage ,
  getRoute ,
  
}
/* Lib-PorterinFusionkitSentry Not a pure module */
